import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CreateCustomerRequest, CustomerDTO, UpdateCustomerRequest } from '../models/customer.model';

@Injectable({ providedIn: 'root' })
export class CustomerService {
  private readonly http = inject(HttpClient);

  getCustomers(): Observable<CustomerDTO[]> {
    return this.http.get<CustomerDTO[]>(`${environment.apiBaseUrl}/api/v1/admin/customers`);
  }

  getById(id: string): Observable<CustomerDTO> {
    return this.http.get<CustomerDTO>(`${environment.apiBaseUrl}/api/v1/admin/customers/${id}`);
  }

  createCustomer(request: CreateCustomerRequest): Observable<CustomerDTO> {
    return this.http.post<CustomerDTO>(`${environment.apiBaseUrl}/api/v1/admin/customers`, request);
  }

  updateCustomer(id: string, request: UpdateCustomerRequest): Observable<CustomerDTO> {
    return this.http.patch<CustomerDTO>(`${environment.apiBaseUrl}/api/v1/admin/customers/${id}`, request);
  }

  deleteCustomer(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiBaseUrl}/api/v1/admin/customers/${id}`);
  }
}
